import { Goal } from '../types';
import { themeColors } from '../../../theme/colors';
import { timeFormatter } from '@act/shared/utilities';

export function determineDateLineTextColor(goal: Goal, dueDate: number) {
  const differenceFromToday = timeFormatter.differenceInDaysFromNow(dueDate);

  let dateColor;

  if (!goal.completed) {
    if (differenceFromToday <= 7 && differenceFromToday >= 0) {
      dateColor = themeColors.warning;
    }

    if (differenceFromToday < 0) {
      dateColor = themeColors.error;
    }
  }

  return dateColor;
}
